import React from "react"
import classNames from "classnames"

import { StaticImage } from "gatsby-plugin-image"

import { pagesLinks } from "../../../_V2/common/links"

import styles from "./styles.module.scss"
import {Locales} from "../../../../localization/types";

export const getData = (locale: Locales) => {
	if (locale === 'ru-BY') {
		return [
			// Сотрудникам зала
			{
				id: 0,
				heading: "Модуль доставки",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Готовое решение для роста бизнеса.
					<br />
					Получай заказы через собственный
					<br />
					сайт или приложение. Подключайся
					<br />
					к агрегаторам для увеличения
					<br />
					клиентской базы.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Готовое решение для роста бизнеса. Получай заказы через собственный
					сайт или приложение. Подключайся к агрегаторам для увеличения клиентской базы.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.delivery.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-delivery-d-BY.png"
							alt="Cлужба доставки для ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(styles.image__tabletAndMobile, styles.delivery)}
							src="./assets/capability-delivery-t&m-BY.png"
							alt="Cлужба доставки для ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			{
				id: 0,
				heading: "Экран повара",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Заказы мгновенно попадают на кухню
					<br />
					и распределяются между поварами.
					<br />
					Для каждого блюда — своя техкарта
					<br />
					со списком ингредиентов. Официант
					<br />
					получает уведомления о статусе
					<br />
					заказа.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Заказы мгновенно попадают на кухню и распределяются между поварами.
					Для каждого блюда — своя техкарта со списком ингредиентов. Официант
					получает уведомления о статусе заказа.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.indexKDS.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-kds-d.png"
							alt="Кухонный дисплей повара"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(styles.image__tabletAndMobile, styles.indexKDS)}
							src="./assets/capability-kds-t&m-BY.png"
							alt="Кухонный дисплей повара"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			// Гостям заведения
			{
				id: 1,
				heading: "Карты лояльности",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Электронные карты лояльности для
					<br />
					твоего бизнеса в Apple Wallet и Google
					<br />
					Pay. Системный подход к бонусным
					<br />
					программам и CRM доступен на
					<br />
					любом тарифе Quick Resto.
					<br />
					Мгновенный выпуск карты.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Электронные карты лояльности для твоего бизнеса в Apple Wallet
					и Google Pay. Системный подход к бонусным программам и CRM доступен на
					любом тарифе Quick Resto. Мгновенный выпуск карты.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.passkit.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-passkit-d.png"
							alt="Карты лояльности для ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(styles.image__tabletAndMobile, styles.passkit)}
							src="./assets/capability-passkit-t&m.png"
							alt="Карты лояльности для ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			{
				id: 1,
				heading: "Электронное меню",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Не нужно ждать, пока напечатают
					<br />
					новое меню. А с акциями можно
					<br />
					экспериментировать хоть каждый
					<br />
					день. Посетитель открывает меню
					<br />
					на смартфоне, зовёт официанта
					<br />
					и делает заказ.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Не нужно ждать, пока напечатают новое меню. А с акциями можно
					экспериментировать хоть каждый день. Посетитель открывает меню
					на смартфоне, зовёт официанта и делает заказ.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.wlShop.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-wlShop-d-BY.png"
							alt="Электронное меню для кафе"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(styles.image__tabletAndMobile, styles.wlShop)}
							src="./assets/capability-wlShop-t&m-BY.png"
							alt="Электронное меню для кафе"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			{
				id: 1,
				heading: "Экран очереди",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Можно отследить статус своего заказе на экране рядом с кассовой зоной, при этом сотрудники не отвлекаются от работы. А гости, пока ждут, могут присмотреть что-то ещё из акций и новинок меню.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Можно отследить статус своего заказе на экране рядом с кассовой зоной,
					при этом сотрудники не отвлекаются от работы. А гости, пока ждут,
					могут присмотреть что-то ещё из акций и новинок меню.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.line.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-line-d.png"
							alt="Экран электронной очереди"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(styles.image__tabletAndMobile, styles.line)}
							src="./assets/capability-line-t&m.png"
							alt="Ээкран электронной очереди"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			{
				id: 1,
				heading: "Экран покупателя",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Планшет размещается на кассе
					<br />
					дисплеем к покупателю — тот видит
					<br />
					все блюда и модификаторы, которые
					<br />
					сотрудник добавляет в заказ,
					<br />
					и сумму к оплате. Меньше ошибок —
					<br />
					выше скорость обслуживания.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Планшет размещается на кассе дисплеем к покупателю — тот видит все
					блюда и модификаторы, которые сотрудник добавляет в заказ, и сумму к
					оплате. Меньше ошибок — выше скорость обслуживания.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.customerDisplay.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-customerDisplay-d-BY.png"
							alt="Экран покупателя в кафе"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(
								styles.image__tabletAndMobile,
								styles.customerDisplay
							)}
							src="./assets/capability-customerDisplay-t&m-BY.png"
							alt="Экран покупателя в кафе"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			// Сотрудникам бэк-офиса
			{
				id: 2,
				heading: "Склад",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Возьми под контроль весь цикл
					<br />
					товарооборота: от закупок и прихода
					<br />
					до списания, актов разбора
					<br />
					и переработки. Система в режиме
					<br />
					реального времени показывает
					<br />
					остатки, недостачи и излишки.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Возьми под контроль весь цикл товарооборота: от закупок и прихода до
					списания, актов разбора и переработки. Система в режиме реального
					времени показывает остатки, недостачи и излишки.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.warehouse.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-warehouse-d-BY.png"
							alt="Технологические карты для ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(
								styles.image__tabletAndMobile,
								styles.warehouse
							)}
							src="./assets/capability-warehouse-t&m-BY.png"
							alt="Технологические карты для ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			{
				id: 2,
				heading: "Персонал",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Поможем контролировать качество и объём работы сотрудников, давать индивидуальные задания на основе аналитики и отслеживать подозрительные операции. Работай в команде!
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Поможем контролировать качество и объём работы сотрудников, давать
					индивидуальные задания на основе аналитики и отслеживать
					подозрительные операции. Работай в команде!
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.staff.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-staff-d-BY.png"
							alt="Персонал в кафе"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(styles.image__tabletAndMobile, styles.staff)}
							src="./assets/capability-staff-t&m-BY.png"
							alt="Персонал в кафе"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			{
				id: 2,
				heading: "Маркетинг и CRM",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Акции, бонусные программы
					<br />и персональные скидки, промо-
					<br />
					купоны и даже больше. С такими
					<br />
					инструментами CRM любой гость
					<br />
					почувствует заботу, выгоду и будет
					<br />
					возвращаться снова и снова.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Акции, бонусные программы и персональные скидки, промо-купоны и даже
					больше. С такими инструментами CRM любой гость почувствует заботу,
					выгоду и будет возвращаться снова и снова.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.marketing.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-marketing-d-BY.png"
							alt="Программы лояльности для ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(
								styles.image__tabletAndMobile,
								styles.marketing
							)}
							src="./assets/capability-marketing-t&m-BY.png"
							alt="Программы лояльности для ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			{
				id: 2,
				heading: "Аналитика",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Наглядные виджеты и детальные
					<br />
					отчёты: поможем принять правильное
					<br />
					решение на любой стадии бизнеса.
					<br />
					Всё в облаке — можно анализировать
					<br />
					данные находясь где угодно.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Наглядные виджеты и детальные отчёты: поможем принять правильное
					решение на любой стадии бизнеса. Всё в облаке — можно анализировать
					данные находясь где угодно.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.reports.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-reports-d-BY.png"
							alt="Отчеты по продажам в ресторане"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(styles.image__tabletAndMobile, styles.reports)}
							src="./assets/capability-reports-t&m-BY.png"
							alt="Отчеты по продажам в ресторане"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			// Руководителям
			{
				id: 3,
				heading: "Уведомления",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Наблюдай за бизнесом в реальном
					<br />
					времени: настрой уведомления
					<br />
					о выручке за день и возвратах чеков.
					<br />
					Следи за количеством гостей
					<br />
					и эффективностью официантов.
					<br />
					Гибкая настройка уведомлений.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Наблюдай за бизнесом в реальном времени: настрой уведомления о выручке
					за день и возвратах чеков. Следи за количеством гостей и
					эффективностью официантов. Гибкая настройка уведомлений.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.notifications.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-notifications-d.png"
							alt="Уведомления для владельца ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(
								styles.image__tabletAndMobile,
								styles.notifications
							)}
							src="./assets/capability-notifications-t&m-BY.png"
							alt="Уведомления для владельца ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			{
				id: 3,
				heading: "Запуск франшизы",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Контролируй работу франчайзи,
					<br />
					анализируй продажи, управляй
					<br />
					всей франшизой дистанционно.
					<br />
					Используй решения Quick Resto
					<br />
					для франшиз и сетей заведений.
					<br />
					Комплексная автоматизация сети.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Контролируй работу франчайзи, анализируй продажи, управляй всей
					франшизой дистанционно. Используй решения Quick Resto для франшиз и
					сетей заведений. Комплексная автоматизация сети.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.franchise.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-franchise-d-BY.png"
							alt="Уведомления для владельца ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(
								styles.image__tabletAndMobile,
								styles.franchise
							)}
							src="./assets/capability-franchise-t&m-BY.png"
							alt="Уведомления для владельца ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
		]
	}
	if (locale === 'ru-KZ') {
		return [
			// Сотрудникам зала
			{
				id: 0,
				heading: "Модуль доставки",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Готовое решение для роста бизнеса.
					<br />
					Получай заказы через собственный
					<br />
					сайт или приложение. Подключайся
					<br />
					к агрегаторам для увеличения
					<br />
					клиентской базы.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Готовое решение для роста бизнеса. Получай заказы через собственный
					сайт или приложение. Подключайся к агрегаторам для увеличения клиентской базы.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.delivery.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-delivery-d-KZ.png"
							alt="Cлужба доставки для ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(styles.image__tabletAndMobile, styles.delivery)}
							src="./assets/capability-delivery-t&m-KZ.png"
							alt="Cлужба доставки для ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			{
				id: 0,
				heading: "Экран повара",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Заказы мгновенно попадают на кухню
					<br />
					и распределяются между поварами.
					<br />
					Для каждого блюда — своя техкарта
					<br />
					со списком ингредиентов. Официант
					<br />
					получает уведомления о статусе
					<br />
					заказа.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Заказы мгновенно попадают на кухню и распределяются между поварами.
					Для каждого блюда — своя техкарта со списком ингредиентов. Официант
					получает уведомления о статусе заказа.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.indexKDS.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-kds-d.png"
							alt="Кухонный дисплей повара"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(styles.image__tabletAndMobile, styles.indexKDS)}
							src="./assets/capability-kds-t&m-KZ.png"
							alt="Кухонный дисплей повара"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			// Гостям заведения
			{
				id: 1,
				heading: "Карты лояльности",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Электронные карты лояльности для
					<br />
					твоего бизнеса в Apple Wallet и Google
					<br />
					Pay. Системный подход к бонусным
					<br />
					программам и CRM доступен на
					<br />
					любом тарифе Quick Resto.
					<br />
					Мгновенный выпуск карты.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Электронные карты лояльности для твоего бизнеса в Apple Wallet
					и Google Pay. Системный подход к бонусным программам и CRM доступен на
					любом тарифе Quick Resto. Мгновенный выпуск карты.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.passkit.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-passkit-d.png"
							alt="Карты лояльности для ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(styles.image__tabletAndMobile, styles.passkit)}
							src="./assets/capability-passkit-t&m.png"
							alt="Карты лояльности для ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			{
				id: 1,
				heading: "Электронное меню",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Не нужно ждать, пока напечатают
					<br />
					новое меню. А с акциями можно
					<br />
					экспериментировать хоть каждый
					<br />
					день. Посетитель открывает меню
					<br />
					на смартфоне, зовёт официанта
					<br />
					и делает заказ.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Не нужно ждать, пока напечатают новое меню. А с акциями можно
					экспериментировать хоть каждый день. Посетитель открывает меню
					на смартфоне, зовёт официанта и делает заказ.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.wlShop.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-wlShop-d-KZ.png"
							alt="Электронное меню для кафе"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(styles.image__tabletAndMobile, styles.wlShop)}
							src="./assets/capability-wlShop-t&m-KZ.png"
							alt="Электронное меню для кафе"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			{
				id: 1,
				heading: "Экран очереди",
				textarea: (
					<>
					<span className={styles.textarea__desktop}>
						Можно отследить статус своего заказе на экране рядом с кассовой зоной, при этом сотрудники не отвлекаются от работы. А гости, пока ждут, могут присмотреть что-то ещё из акций и новинок меню.
					</span>
						<span className={styles.textarea__tabletAndMobile}>
					Можно отследить статус своего заказе на экране рядом с кассовой зоной,
					при этом сотрудники не отвлекаются от работы. А гости, пока ждут,
					могут присмотреть что-то ещё из акций и новинок меню.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.line.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-line-d.png"
							alt="Экран электронной очереди"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(styles.image__tabletAndMobile, styles.line)}
							src="./assets/capability-line-t&m.png"
							alt="Ээкран электронной очереди"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			{
				id: 1,
				heading: "Экран покупателя",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Планшет размещается на кассе
					<br />
					дисплеем к покупателю — тот видит
					<br />
					все блюда и модификаторы, которые
					<br />
					сотрудник добавляет в заказ,
					<br />
					и сумму к оплате. Меньше ошибок —
					<br />
					выше скорость обслуживания.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Планшет размещается на кассе дисплеем к покупателю — тот видит все
					блюда и модификаторы, которые сотрудник добавляет в заказ, и сумму к
					оплате. Меньше ошибок — выше скорость обслуживания.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.customerDisplay.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-customerDisplay-d-KZ.png"
							alt="Экран покупателя в кафе"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(
								styles.image__tabletAndMobile,
								styles.customerDisplay
							)}
							src="./assets/capability-customerDisplay-t&m-KZ.png"
							alt="Экран покупателя в кафе"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			// Сотрудникам бэк-офиса
			{
				id: 2,
				heading: "Склад",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Возьми под контроль весь цикл
					<br />
					товарооборота: от закупок и прихода
					<br />
					до списания, актов разбора
					<br />
					и переработки. Система в режиме
					<br />
					реального времени показывает
					<br />
					остатки, недостачи и излишки.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Возьми под контроль весь цикл товарооборота: от закупок и прихода до
					списания, актов разбора и переработки. Система в режиме реального
					времени показывает остатки, недостачи и излишки.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.warehouse.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-warehouse-d-KZ.png"
							alt="Технологические карты для ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(
								styles.image__tabletAndMobile,
								styles.warehouse
							)}
							src="./assets/capability-warehouse-t&m-KZ.png"
							alt="Технологические карты для ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			{
				id: 2,
				heading: "Персонал",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Поможем контролировать качество и<br />
					объём работы сотрудников, давать
					<br />
					индивидуальные задания на основе
					<br />
					аналитики и отслеживать
					<br />
					подозрительные операции. Работай в<br />
					команде!
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Поможем контролировать качество и объём работы сотрудников, давать
					индивидуальные задания на основе аналитики и отслеживать
					подозрительные операции. Работай в команде!
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.staff.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-staff-d-KZ.png"
							alt="Персонал в кафе"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(styles.image__tabletAndMobile, styles.staff)}
							src="./assets/capability-staff-t&m-KZ.png"
							alt="Персонал в кафе"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			{
				id: 2,
				heading: "Маркетинг и CRM",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Акции, бонусные программы
					<br />и персональные скидки, промо-
					<br />
					купоны и даже больше. С такими
					<br />
					инструментами CRM любой гость
					<br />
					почувствует заботу, выгоду и будет
					<br />
					возвращаться снова и снова.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Акции, бонусные программы и персональные скидки, промо-купоны и даже
					больше. С такими инструментами CRM любой гость почувствует заботу,
					выгоду и будет возвращаться снова и снова.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.marketing.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-marketing-d-KZ.png"
							alt="Программы лояльности для ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(
								styles.image__tabletAndMobile,
								styles.marketing
							)}
							src="./assets/capability-marketing-t&m-KZ.png"
							alt="Программы лояльности для ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			{
				id: 2,
				heading: "Аналитика",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Наглядные виджеты и детальные
					<br />
					отчёты: поможем принять правильное
					<br />
					решение на любой стадии бизнеса.
					<br />
					Всё в облаке — можно анализировать
					<br />
					данные находясь где угодно.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Наглядные виджеты и детальные отчёты: поможем принять правильное
					решение на любой стадии бизнеса. Всё в облаке — можно анализировать
					данные находясь где угодно.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.reports.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-reports-d-KZ.png"
							alt="Отчеты по продажам в ресторане"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(styles.image__tabletAndMobile, styles.reports)}
							src="./assets/capability-reports-t&m-KZ.png"
							alt="Отчеты по продажам в ресторане"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			// Руководителям
			{
				id: 3,
				heading: "Уведомления",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Наблюдай за бизнесом в реальном
					<br />
					времени: настрой уведомления
					<br />
					о выручке за день и возвратах чеков.
					<br />
					Следи за количеством гостей
					<br />
					и эффективностью официантов.
					<br />
					Гибкая настройка уведомлений.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Наблюдай за бизнесом в реальном времени: настрой уведомления о выручке
					за день и возвратах чеков. Следи за количеством гостей и
					эффективностью официантов. Гибкая настройка уведомлений.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.notifications.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-notifications-d.png"
							alt="Уведомления для владельца ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(
								styles.image__tabletAndMobile,
								styles.notifications
							)}
							src="./assets/capability-notifications-t&m-KZ.png"
							alt="Уведомления для владельца ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
			{
				id: 3,
				heading: "Запуск франшизы",
				textarea: (
					<>
				<span className={styles.textarea__desktop}>
					Контролируй работу франчайзи,
					<br />
					анализируй продажи, управляй
					<br />
					всей франшизой дистанционно.
					<br />
					Используй решения Quick Resto
					<br />
					для франшиз и сетей заведений.
					<br />
					Комплексная автоматизация сети.
				</span>
						<span className={styles.textarea__tabletAndMobile}>
					Контролируй работу франчайзи, анализируй продажи, управляй всей
					франшизой дистанционно. Используй решения Quick Resto для франшиз и
					сетей заведений. Комплексная автоматизация сети.
				</span>
					</>
				),
				btn: {
					text: "Подробнее",
					url: pagesLinks.franchise.href,
					useGatsbyLink: true
				},
				mediaContent: (
					<>
						<StaticImage
							className={styles.image__desktop}
							src="./assets/capability-franchise-d-KZ.png"
							alt="Уведомления для владельца ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
						<StaticImage
							className={classNames(
								styles.image__tabletAndMobile,
								styles.franchise
							)}
							src="./assets/capability-franchise-t&m-KZ.png"
							alt="Уведомления для владельца ресторана"
							objectFit="contain"
							placeholder="blurred"
							quality={100}
						/>
					</>
				),
			},
		]
	}
	return [
		// Сотрудникам зала
		{
			id: 0,
			heading: "Модуль доставки",
			textarea: (
				<>
				<span className={styles.textarea__desktop}>
					Готовое решение для роста бизнеса.
					<br />
					Получай заказы через собственный
					<br />
					сайт или приложение. Подключайся
					<br />
					к агрегаторам для увеличения
					<br />
					клиентской базы.
				</span>
					<span className={styles.textarea__tabletAndMobile}>
					Готовое решение для роста бизнеса. Получай заказы через собственный
					сайт или приложение. Подключайся к агрегаторам для увеличения клиентской базы.
				</span>
				</>
			),
			btn: {
				text: "Подробнее",
				url: pagesLinks.delivery.href,
				useGatsbyLink: true
			},
			mediaContent: (
				<>
					<StaticImage
						className={styles.image__desktop}
						src="./assets/capability-delivery-d.png"
						alt="Cлужба доставки для ресторана"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
					<StaticImage
						className={classNames(styles.image__tabletAndMobile, styles.delivery)}
						src="./assets/capability-delivery-t&m.png"
						alt="Cлужба доставки для ресторана"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
				</>
			),
		},
		{
			id: 0,
			heading: "Экран повара",
			textarea: (
				<>
				<span className={styles.textarea__desktop}>
					Заказы мгновенно попадают на кухню
					<br />
					и распределяются между поварами.
					<br />
					Для каждого блюда — своя техкарта
					<br />
					со списком ингредиентов. Официант
					<br />
					получает уведомления о статусе
					<br />
					заказа.
				</span>
					<span className={styles.textarea__tabletAndMobile}>
					Заказы мгновенно попадают на кухню и распределяются между поварами.
					Для каждого блюда — своя техкарта со списком ингредиентов. Официант
					получает уведомления о статусе заказа.
				</span>
				</>
			),
			btn: {
				text: "Подробнее",
				url: pagesLinks.indexKDS.href,
				useGatsbyLink: true
			},
			mediaContent: (
				<>
					<StaticImage
						className={styles.image__desktop}
						src="./assets/capability-kds-d.png"
						alt="Кухонный дисплей повара"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
					<StaticImage
						className={classNames(styles.image__tabletAndMobile, styles.indexKDS)}
						src="./assets/capability-kds-t&m.png"
						alt="Кухонный дисплей повара"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
				</>
			),
		},
		// Гостям заведения
		{
			id: 1,
			heading: "Карты лояльности",
			textarea: (
				<>
				<span className={styles.textarea__desktop}>
					Электронные карты лояльности для
					<br />
					твоего бизнеса в Apple Wallet и Google
					<br />
					Pay. Системный подход к бонусным
					<br />
					программам и CRM доступен на
					<br />
					любом тарифе Quick Resto.
					<br />
					Мгновенный выпуск карты.
				</span>
					<span className={styles.textarea__tabletAndMobile}>
					Электронные карты лояльности для твоего бизнеса в Apple Wallet
					и Google Pay. Системный подход к бонусным программам и CRM доступен на
					любом тарифе Quick Resto. Мгновенный выпуск карты.
				</span>
				</>
			),
			btn: {
				text: "Подробнее",
				url: pagesLinks.passkit.href,
				useGatsbyLink: true
			},
			mediaContent: (
				<>
					<StaticImage
						className={styles.image__desktop}
						src="./assets/capability-passkit-d.png"
						alt="Карты лояльности для ресторана"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
					<StaticImage
						className={classNames(styles.image__tabletAndMobile, styles.passkit)}
						src="./assets/capability-passkit-t&m.png"
						alt="Карты лояльности для ресторана"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
				</>
			),
		},
		{
			id: 1,
			heading: "Электронное меню",
			textarea: (
				<>
				<span className={styles.textarea__desktop}>
					Не нужно ждать, пока напечатают
					<br />
					новое меню. А с акциями можно
					<br />
					экспериментировать хоть каждый
					<br />
					день. Посетитель открывает меню
					<br />
					на смартфоне, зовёт официанта
					<br />
					и делает заказ.
				</span>
					<span className={styles.textarea__tabletAndMobile}>
					Не нужно ждать, пока напечатают новое меню. А с акциями можно
					экспериментировать хоть каждый день. Посетитель открывает меню
					на смартфоне, зовёт официанта и делает заказ.
				</span>
				</>
			),
			btn: {
				text: "Подробнее",
				url: pagesLinks.wlShop.href,
				useGatsbyLink: true
			},
			mediaContent: (
				<>
					<StaticImage
						className={styles.image__desktop}
						src="./assets/capability-wlShop-d.png"
						alt="Электронное меню для кафе"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
					<StaticImage
						className={classNames(styles.image__tabletAndMobile, styles.wlShop)}
						src="./assets/capability-wlShop-t&m.png"
						alt="Электронное меню для кафе"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
				</>
			),
		},
		{
			id: 1,
			heading: "Экран очереди",
			textarea: (
				<>
				<span className={styles.textarea__desktop}>
					Можно отследить статус своего заказе
					<br />
					на экране рядом с кассовой зоной,
					<br />
					при этом сотрудники
					<br />
					не отвлекаются от работы. А гости,
					<br />
					пока ждут, могут присмотреть что-то
					<br />
					ещё из акций и новинок меню.
				</span>
					<span className={styles.textarea__tabletAndMobile}>
					Можно отследить статус своего заказе на экране рядом с кассовой зоной,
					при этом сотрудники не отвлекаются от работы. А гости, пока ждут,
					могут присмотреть что-то ещё из акций и новинок меню.
				</span>
				</>
			),
			btn: {
				text: "Подробнее",
				url: pagesLinks.line.href,
				useGatsbyLink: true
			},
			mediaContent: (
				<>
					<StaticImage
						className={styles.image__desktop}
						src="./assets/capability-line-d.png"
						alt="Экран электронной очереди"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
					<StaticImage
						className={classNames(styles.image__tabletAndMobile, styles.line)}
						src="./assets/capability-line-t&m.png"
						alt="Ээкран электронной очереди"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
				</>
			),
		},
		{
			id: 1,
			heading: "Экран покупателя",
			textarea: (
				<>
				<span className={styles.textarea__desktop}>
					Планшет размещается на кассе
					<br />
					дисплеем к покупателю — тот видит
					<br />
					все блюда и модификаторы, которые
					<br />
					сотрудник добавляет в заказ,
					<br />
					и сумму к оплате. Меньше ошибок —
					<br />
					выше скорость обслуживания.
				</span>
					<span className={styles.textarea__tabletAndMobile}>
					Планшет размещается на кассе дисплеем к покупателю — тот видит все
					блюда и модификаторы, которые сотрудник добавляет в заказ, и сумму к
					оплате. Меньше ошибок — выше скорость обслуживания.
				</span>
				</>
			),
			btn: {
				text: "Подробнее",
				url: pagesLinks.customerDisplay.href,
				useGatsbyLink: true
			},
			mediaContent: (
				<>
					<StaticImage
						className={styles.image__desktop}
						src="./assets/capability-customerDisplay-d.png"
						alt="Экран покупателя в кафе"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
					<StaticImage
						className={classNames(
							styles.image__tabletAndMobile,
							styles.customerDisplay
						)}
						src="./assets/capability-customerDisplay-t&m.png"
						alt="Экран покупателя в кафе"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
				</>
			),
		},
		// Сотрудникам бэк-офиса
		{
			id: 2,
			heading: "Склад",
			textarea: (
				<>
				<span className={styles.textarea__desktop}>
					Возьми под контроль весь цикл
					<br />
					товарооборота: от закупок и прихода
					<br />
					до списания, актов разбора
					<br />
					и переработки. Система в режиме
					<br />
					реального времени показывает
					<br />
					остатки, недостачи и излишки.
				</span>
					<span className={styles.textarea__tabletAndMobile}>
					Возьми под контроль весь цикл товарооборота: от закупок и прихода до
					списания, актов разбора и переработки. Система в режиме реального
					времени показывает остатки, недостачи и излишки.
				</span>
				</>
			),
			btn: {
				text: "Подробнее",
				url: pagesLinks.warehouse.href,
				useGatsbyLink: true
			},
			mediaContent: (
				<>
					<StaticImage
						className={styles.image__desktop}
						src="./assets/capability-warehouse-d.png"
						alt="Технологические карты для ресторана"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
					<StaticImage
						className={classNames(
							styles.image__tabletAndMobile,
							styles.warehouse
						)}
						src="./assets/capability-warehouse-t&m.png"
						alt="Технологические карты для ресторана"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
				</>
			),
		},
		{
			id: 2,
			heading: "Персонал",
			textarea: (
				<>
				<span className={styles.textarea__desktop}>
					Поможем контролировать качество и<br />
					объём работы сотрудников, давать
					<br />
					индивидуальные задания на основе
					<br />
					аналитики и отслеживать
					<br />
					подозрительные операции. Работай в<br />
					команде!
				</span>
					<span className={styles.textarea__tabletAndMobile}>
					Поможем контролировать качество и объём работы сотрудников, давать
					индивидуальные задания на основе аналитики и отслеживать
					подозрительные операции. Работай в команде!
				</span>
				</>
			),
			btn: {
				text: "Подробнее",
				url: pagesLinks.staff.href,
				useGatsbyLink: true
			},
			mediaContent: (
				<>
					<StaticImage
						className={styles.image__desktop}
						src="./assets/capability-staff-d.png"
						alt="Персонал в кафе"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
					<StaticImage
						className={classNames(styles.image__tabletAndMobile, styles.staff)}
						src="./assets/capability-staff-t&m.png"
						alt="Персонал в кафе"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
				</>
			),
		},
		{
			id: 2,
			heading: "Маркетинг и CRM",
			textarea: (
				<>
				<span className={styles.textarea__desktop}>
					Акции, бонусные программы
					<br />и персональные скидки, промо-
					<br />
					купоны и даже больше. С такими
					<br />
					инструментами CRM любой гость
					<br />
					почувствует заботу, выгоду и будет
					<br />
					возвращаться снова и снова.
				</span>
					<span className={styles.textarea__tabletAndMobile}>
					Акции, бонусные программы и персональные скидки, промо-купоны и даже
					больше. С такими инструментами CRM любой гость почувствует заботу,
					выгоду и будет возвращаться снова и снова.
				</span>
				</>
			),
			btn: {
				text: "Подробнее",
				url: pagesLinks.marketing.href,
				useGatsbyLink: true
			},
			mediaContent: (
				<>
					<StaticImage
						className={styles.image__desktop}
						src="./assets/capability-marketing-d.png"
						alt="Программы лояльности для ресторана"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
					<StaticImage
						className={classNames(
							styles.image__tabletAndMobile,
							styles.marketing
						)}
						src="./assets/capability-marketing-t&m.png"
						alt="Программы лояльности для ресторана"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
				</>
			),
		},
		{
			id: 2,
			heading: "Аналитика",
			textarea: (
				<>
				<span className={styles.textarea__desktop}>
					Наглядные виджеты и детальные
					<br />
					отчёты: поможем принять правильное
					<br />
					решение на любой стадии бизнеса.
					<br />
					Всё в облаке — можно анализировать
					<br />
					данные находясь где угодно.
				</span>
					<span className={styles.textarea__tabletAndMobile}>
					Наглядные виджеты и детальные отчёты: поможем принять правильное
					решение на любой стадии бизнеса. Всё в облаке — можно анализировать
					данные находясь где угодно.
				</span>
				</>
			),
			btn: {
				text: "Подробнее",
				url: pagesLinks.reports.href,
				useGatsbyLink: true
			},
			mediaContent: (
				<>
					<StaticImage
						className={styles.image__desktop}
						src="./assets/capability-reports-d.png"
						alt="Отчеты по продажам в ресторане"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
					<StaticImage
						className={classNames(styles.image__tabletAndMobile, styles.reports)}
						src="./assets/capability-reports-t&m.png"
						alt="Отчеты по продажам в ресторане"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
				</>
			),
		},
		// Руководителям
		{
			id: 3,
			heading: "Уведомления",
			textarea: (
				<>
				<span className={styles.textarea__desktop}>
					Наблюдай за бизнесом в реальном
					<br />
					времени: настрой уведомления
					<br />
					о выручке за день и возвратах чеков.
					<br />
					Следи за количеством гостей
					<br />
					и эффективностью официантов.
					<br />
					Гибкая настройка уведомлений.
				</span>
					<span className={styles.textarea__tabletAndMobile}>
					Наблюдай за бизнесом в реальном времени: настрой уведомления о выручке
					за день и возвратах чеков. Следи за количеством гостей и
					эффективностью официантов. Гибкая настройка уведомлений.
				</span>
				</>
			),
			btn: {
				text: "Подробнее",
				url: pagesLinks.notifications.href,
				useGatsbyLink: true
			},
			mediaContent: (
				<>
					<StaticImage
						className={styles.image__desktop}
						src="./assets/capability-notifications-d.png"
						alt="Уведомления для владельца ресторана"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
					<StaticImage
						className={classNames(
							styles.image__tabletAndMobile,
							styles.notifications
						)}
						src="./assets/capability-notifications-t&m.png"
						alt="Уведомления для владельца ресторана"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
				</>
			),
		},
		{
			id: 3,
			heading: "Запуск франшизы",
			textarea: (
				<>
				<span className={styles.textarea__desktop}>
					Контролируй работу франчайзи,
					<br />
					анализируй продажи, управляй
					<br />
					всей франшизой дистанционно.
					<br />
					Используй решения Quick Resto
					<br />
					для франшиз и сетей заведений.
					<br />
					Комплексная автоматизация сети.
				</span>
					<span className={styles.textarea__tabletAndMobile}>
					Контролируй работу франчайзи, анализируй продажи, управляй всей
					франшизой дистанционно. Используй решения Quick Resto для франшиз и
					сетей заведений. Комплексная автоматизация сети.
				</span>
				</>
			),
			btn: {
				text: "Подробнее",
				url: pagesLinks.franchise.href,
				useGatsbyLink: true
			},
			mediaContent: (
				<>
					<StaticImage
						className={styles.image__desktop}
						src="./assets/capability-franchise-d.png"
						alt="Уведомления для владельца ресторана"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
					<StaticImage
						className={classNames(
							styles.image__tabletAndMobile,
							styles.franchise
						)}
						src="./assets/capability-franchise-t&m.png"
						alt="Уведомления для владельца ресторана"
						objectFit="contain"
						placeholder="blurred"
						quality={100}
					/>
				</>
			),
		},
	]
}
